<h1>Post Product Details <button type="button" (click)="CloseModal()" class="btn btn-default float-right">Close</button>
</h1>
<div class="row" *ngIf="!dataLoaded"><i class="fa fa-spin fa-spinner"></i></div>
<div class="row" *ngIf="dataLoaded">
    <div class="col-sm-8 border-right">
        <form [formGroup]="productForm" (submit)="productSubmit()">
            <div class="form-group">
                <div class="row">
                    <div class="col-sm-6 mt-5">
                        <label class="form-label">Patient Name *</label>
                        <input type="text" formControlName="patient_name" class="form-control readOnly" />
                        <div *ngIf="submitted && f.patient_name.errors" class="invalid-feedback">
                            <div *ngIf="f.patient_name.errors.required">Patient Name is required</div>
                        </div>
                        <div *ngIf="(f.patient_name.value=='NA' || f.patient_name.value=='N/A') && invalidName"
                            class="invalid-feedback">
                            <div>Please enter valid name</div>
                        </div>
                    </div>

                    <div class="col-sm-6 mt-5">
                        <label class="form-label">Patient Mobile *</label>
                        <input type="text" class="form-control readOnly" value="XXXXXXXXXX" />
                        <div *ngIf="submitted && f.mobile.errors" class="invalid-feedback">
                            <div *ngIf="f.mobile.errors.required">Patient Mobile is required</div>
                        </div>
                    </div>

                    <div class="col-sm-6 mt-5">
                        <label class="form-label">Select BD *</label>
                        <mat-select placeholder="Select BD" class="readOnly" formControlName="user_id"
                            (click)="setSearchValue('lead_owner')">
                            <input class="mySearchInput readOnly" #ownerSearch focused="'true'" type="text"
                                (keyup)="searchOnSelect($event.target.value, 'lead_owner')"
                                (keydown)="$event.stopPropagation()" autocomplete="off" placeholder="Search"
                                id="ownerSearch">
                            <mat-option value="">Select BD</mat-option>
                            <mat-option [value]="bd.id" *ngFor="let bd of bds">{{bd.name}}</mat-option>
                        </mat-select>
                        <div *ngIf="submitted && f.user_id.errors" class="invalid-feedback">
                            <div *ngIf="f.user_id.errors.required">BD is required</div>
                        </div>
                    </div>

                    <div class="col-sm-6 mt-5">
                        <label class="form-label">Patient Age*</label>
                        <input type="number" formControlName="patient_age" class="form-control readOnly" />
                        <div *ngIf="submitted && f.patient_age.errors" class="invalid-feedback">
                            <div *ngIf="f.patient_age.errors.required">Age is required</div>
                        </div>
                    </div>
                    <div class="col-sm-6 mt-5">
                        <label class="form-label">Gender*</label>
                        <mat-select placeholder="Gender" formControlName="gender" class="readOnly">
                            <mat-option value="Male">Male</mat-option>
                            <mat-option value="Female">Female</mat-option>
                        </mat-select>
                        <div *ngIf="submitted && f.gender.errors" class="invalid-feedback">
                            <div *ngIf="f.gender.errors.required">Gender is required</div>
                        </div>

                    </div>

                    <div class="col-sm-6 mt-5">
                        <label class="form-label">Booking Date*</label>
                        <input type="date" formControlName="booking_date" class="form-control" />
                        <div *ngIf="submitted && f.booking_date.errors" class="invalid-feedback">
                            <div *ngIf="f.booking_date.errors.required">Booking Date is required</div>
                        </div>
                    </div>

                    <div class="col-sm-6 mt-5">
                        <label class="form-label">Select Clinic</label>
                        <mat-select placeholder="Select Clinic" formControlName="hospital_id" (click)="setSearchValue('hospital')">
                            <input class="mySearchInput"
                            #hospitalSearch focused="'true'" type="text"
                            (keyup)="searchOnSelect($event.target.value, 'hospital')"
                            (keydown)="$event.stopPropagation()" autocomplete="off"
                            placeholder="Search"
                            id="hospitalSearch">
                            <mat-option value="">Select Hospital</mat-option>
                            <mat-option [value]="hospital.id" *ngFor="let hospital of hospitals">{{hospital.name}}</mat-option>
                        </mat-select>
                    </div>

                    <div class="col-sm-6 mt-5">
                        <label class="form-label">Area Pin Code</label>
                        <input type="text" formControlName="pin_code" class="form-control" />
                    </div>

                    <div class="col-sm-6 mt-5">
                        <label class="form-label">Address</label>
                        <textarea class="form-control" formControlName="address" rows="2"></textarea>
                        <!-- <input type="text" formControlName="address" class="form-control" /> -->
                    </div>

                </div>

                <!-- new -->
                <div class="row">
                    <div class="col-sm-12 mt-5">
                        <button type="button" (click)="addMoreProductDetail()" class="btn btn-success pull-left"> Add More Product + </button>
                    </div>
                </div>
                <div class="col-sm-12" formArrayName="productDetails" style="display: contents;">
                    <div class="row mt-5"
                        *ngFor="let productquantity of receivedProductResources().controls; let i=index"
                        [formGroupName]="i">
                        <div class="col-sm-6 mt-2">
                            <label class="form-label">Product*</label>
                            <mat-select placeholder="Product" formControlName="product_id" (click)="setSearchValue('product')">
                                <input class="mySearchInput"
                                #productSearch focused="'true'" type="text"
                                (keyup)="searchOnSelect($event.target.value, 'product')"
                                (keydown)="$event.stopPropagation()" autocomplete="off"
                                placeholder="Search"
                                id="productSearch">
                                <mat-option [value]="product.id" *ngFor="let product of all_product_list">{{product.name}}</mat-option>
                            </mat-select>
                            <div *ngIf="submitted && productquantity.get('product_id').invalid">
                                <div class="invalid-feedback">Product is required</div>
                            </div>
                        </div>
                        <div class="col-sm-3 mt-2">
                            <label class="form-label">Quantity*</label>
                            <input type="number" formControlName="product_quantity" class="form-control" min="1" />
                            <div *ngIf="submitted && productquantity.get('product_quantity').invalid">
                                <div class="invalid-feedback">Quantity is required</div>
                            </div>
                        </div>
                        <div class="col-sm-3 mt-2">
                            <label class="form-label">&nbsp;</label>
                            <button class="btn btn-danger" mwlConfirmationPopover [popoverTitle]="popoverTitle"
                                [popoverMessage]="popoverMessage" [confirmText]="confirmText" [cancelText]="cancelText"
                                [placement]="placement"
                                (confirm)="removeProductQuantity(i, productquantity.value.productDetailId)"
                                (cancel)="cancelClicked = true" confirmButtonType="danger"
                                cancelButtonType="outline-secondary"
                                (click)="confirmClicked = false; cancelClicked = false" [appendToBody]="true" 
                                *ngIf="i > 0">
                                Remove
                            </button>
                        </div>
                    </div>
                </div>
                <!-- end -->
                <div class="row mt-5">
                    <div class="col-sm-6 mt-5">
                        <label class="form-label">Alt. Number</label>
                        <input type="text" formControlName="alt_number" class="form-control" />
                    </div>

                    <div class="col-sm-6 mt-5">
                        <label class="form-label">Invoice Amount*</label>
                        <input type="text" formControlName="invoice_amount" class="form-control" />
                        <div *ngIf="submitted && f.invoice_amount.errors" class="invalid-feedback">
                            <div *ngIf="f.invoice_amount.errors.required">Invoice amount is required</div>
                        </div>
                    </div>

                    <div class="col-sm-6 mt-5">
                        <label class="form-label">Status*</label>
                        <mat-select placeholder="Status" formControlName="status">
                            <mat-option [value]="1">New</mat-option>
                            <mat-option [value]="2">Verified</mat-option>
                            <mat-option [value]="3">Pending</mat-option>
                            <mat-option [value]="4">RTO</mat-option>
                            <mat-option [value]="5">Delivered</mat-option>
                            <mat-option [value]="6">Postponed</mat-option>
                            <mat-option [value]="7">Dispatched</mat-option>
                            <mat-option [value]="8">Cancelled</mat-option>
                        </mat-select>
                        <div *ngIf="submitted && f.status.errors" class="invalid-feedback">
                            <div *ngIf="f.status.errors.required">Status is required</div>
                        </div>
                    </div>

                    <div class="col-sm-6 mt-5">
                        <label class="form-label">Description</label>
                        <textarea class="form-control" formControlName="description" rows="2"></textarea>
                    </div>

                    <input type="hidden" formControlName="mobile" class="form-control" />

                </div>
                <div class="row">
                    <div class="col-sm-12 mt-5">
                        <button type="button" (click)="addMoreReceivedAmount()" class="btn btn-primary pull-left"> Add Received Amount +</button>
                    </div>
                </div>
                <div class="col-sm-12" formArrayName="receivedAmtResources" style="display: contents;">
                    <div class="row mt-5" *ngFor="let quantity of receivedAmtResources().controls; let i=index"
                        [formGroupName]="i">
                        <div class="col-sm-4 mt-2">
                            <label class="form-label">Partial Amount*</label>
                            <input type="text" formControlName="partial_amount" placeholder="Partial Amount"
                                class="form-control" />
                            <div *ngIf="submitted && quantity.get('receivedAmtResources').invalid">
                                <div class="invalid-feedback">Partial amount is required</div>
                            </div>
                        </div>
                        <div class="col-sm-4 mt-2">
                            <label class="form-label">Payment Mode*</label>
                            <mat-select placeholder="Payment Mode" formControlName="payment_mode">
                                <mat-option [value]="1">COD</mat-option>
                                <mat-option [value]="2">Partial-COD</mat-option>
                                <mat-option [value]="3">Prepaid</mat-option>
                            </mat-select>
                            <div *ngIf="submitted && quantity.get('payment_mode').invalid">
                                <div class="invalid-feedback">Payment mode is required</div>
                            </div>
                        </div>
                        <div class="col-sm-4 mt-2">
                            <label class="form-label">&nbsp;</label>
                            <button class="btn btn-danger" mwlConfirmationPopover [popoverTitle]="popoverTitle"
                                [popoverMessage]="popoverMessage" [confirmText]="confirmText" [cancelText]="cancelText"
                                [placement]="placement" (confirm)="removeQuantity(i, quantity.value.productPaymentId)"
                                (cancel)="cancelClicked = true" confirmButtonType="danger"
                                cancelButtonType="outline-secondary"
                                (click)="confirmClicked = false; cancelClicked = false" [appendToBody]="true" 
                                *ngIf="i!=0 || quantity.value.productPaymentId==''">
                                Remove
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="card-footer mt-4">
                <button type="submit" [disabled]="loading" class="btn btn-primary"><i *ngIf="loading"
                        class="fa fa-spin fa-spinner"></i> Update</button>
            </div>
        </form>
    </div>

    <div class="col-sm-4" *ngIf="ProductChk">
        <h2>Upload Product Documents</h2>
        <div class="form-group">
            <label>Select Document Type</label>
            <mat-select [(ngModel)]="doc_type" placeholder="Select Document Type">
                <mat-option value="">Select Document Type</mat-option>
                <mat-option [value]="1">Bill Copy</mat-option>
            </mat-select>
        </div>
        <div class="form-group">
            <label>Upload Documents</label>
            <input [disabled]="uploading" type="file" (change)="selectFile($event)" class="form-control" />
            <span *ngIf="uploading"><i class="fa fa-spin fa-spinner"></i> Uploading...</span>
        </div>

        <div class="list-group list-group-flush list-group-hoverable">
            <p *ngIf="fileDeleting"><i class="fa fa-spin fa-spinner"></i> deleting file...</p>
            <div class="list-group-item" *ngFor="let upload of allUploads">
                <div class="row align-items-center">
                    <div class="col text-truncate">
                        <a href="{{s3url}}{{upload.filepath}}" target="_blank" class="text-body d-block">View File</a>
                        <a *ngIf="myrole=='1'" class="delete-file" mwlConfirmationPopover [popoverTitle]="popoverTitle"
                            [popoverMessage]="popoverMessage" [confirmText]="confirmText" [cancelText]="cancelText"
                            [placement]="placement" (confirm)="removeFile(upload.id)" (cancel)="cancelClicked = true"
                            confirmButtonType="danger" cancelButtonType="outline-secondary"
                            (click)="confirmClicked = false; cancelClicked = false" [appendToBody]="true"><i
                                class="fa fa-trash"></i></a>

                        <span class="badge badge-danger" *ngIf='upload.upload_type==1'>Bill Copy</span>
                        <small class="d-block text-muted text-truncate mt-n1">{{upload.filepath}}</small>
                    </div>
                </div>
            </div>
        </div>
    </div>

</div>